import { render, staticRenderFns } from "./ArrearsProcessLog.vue?vue&type=template&id=87d12942"
import script from "./ArrearsProcessLog.vue?vue&type=script&lang=js"
export * from "./ArrearsProcessLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports